import { v4 as uuidv4 } from 'uuid';
import EventEmitter from './EventEmitter';

class FireAndForgetEmitter {
  constructor() {
    this.init();
  }

  init() {
    if (this.emitter?.listeners) {
      this.emitter.listeners = {};
    }
    this.emitter = new EventEmitter();
    this.uuid = uuidv4();
    return this.uuid;
  }

  on(event, listener) {
    this.emitter.on(event, listener);
    return this.uuid;
  }

  fireAndForget(event, ...args) {
    this.emitter.emit(event, ...args);
    return this.init();
  }
}

/**
 * Creates a new event emitter instance with UUID tracking
 *
 * This utility creates an event emitter that automatically generates a unique UUID
 * for each instance and provides a fireAndForget method that resets the emitter
 * after firing an event.
 *
 * @returns {Object} An emitter instance with init(), on(), and fireAndForget() methods
 */
function createFireAndForgetEmitter() {
  return new FireAndForgetEmitter();
}

export default createFireAndForgetEmitter;
